import Component from "./form.component";
import { Config } from "./form.config";
import { watchForm as saga } from "./redux/form.sagas";
import { reducer } from "./redux/form.reducer";

export default { Component, saga, reducer, config: Config };
